var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClickHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 17,
    viewBox: "0 0 62 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Click_Here",
    "data-name": "Click Here",
    transform: "translate(31 13)",
    fill: "#23524c",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30,
    y: 0
  }, "Click Here"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickHere);
export default __webpack_public_path__ + "static/media/Click Here.90553b6cbeacb13af27e04e9192736b3.svg";
export { ForwardRef as ReactComponent };